import eventBus from "../../../../main";
import apiServices from "../../../../../services/apiServices";

export default {
  state: {
    balanceReport: "",
    chartTransactionEnt: ""
  },
  mutations: {
    SET_BALANCE_REPORT(state, value) {
      state.balanceReport = value;
    },
    SET_CHART_ENT(state, value) {
      state.chartTransactionEnt = value;
    }
  },
  actions: {
    getBalanceReportToView(context, ref) {
      apiServices
        .getBReportToView(ref)
        .then(function(response) {
          if (response.status === 200 || response.status === 300) {
            let obj = response.data;
            context.commit("SET_BALANCE_REPORT", obj.message);
          } else {
            let payload = {
              color: "info",
              text: "Não há dados disponíveis",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center",
            top: "top"
          };
          if (error == "Error: Network Error") {
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center",
              top: "top"
            }); // emit the event to the bus
          }

          console.log(error);
          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },

    getExportCsv(context, ref) {
      apiServices
        .getReportCSV(ref)
        .then(function(response) {
          if (response.status === 200 || response.status === 300) {
            let payload = {
              color: "success",
              text: "A gerar relatório...",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            const d = new Date();
            let year =
              d.getFullYear() +
              "_" +
              d.getMonth() +
              "_" +
              d.getDay() +
              "_" +
              d.getSeconds();
            const nameReport = "report_kyami_pay_" + year + ".csv";
            link.setAttribute("download", nameReport);
            document.body.appendChild(link);
            link.click();
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center",
            top: "top"
          };
          if (error == "Error: Network Error") {
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center",
              top: "top"
            }); // emit the event to the bus
          }

          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    },

    chartTransactionEnt(context, ref) {
      apiServices
        .getChartTransactionEnt(ref)
        .then(function(response) {
          if (response.status === 200 || response.status === 300) {
            let obj = response.data;
            // let b64 = btoa(obj.message);
            // localStorage.setItem("sibs_I", b64);
            return context.commit("SET_CHART_ENT", obj.message);
          } else {
            let payload = {
              color: "info",
              text: "Não há dados disponíveis",
              errorLogin: true,
              right: "center",
              top: "top"
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function(error) {
          let payload = {
            color: "error",
            text: "Ups! Seu pedido não foi processado",
            errorLogin: true,
            right: "center",
            top: "top"
          };
          if (error == "Error: Network Error") {
            return eventBus.$emit("openInfo", {
              color: "error",
              text: "Verifique a sua conexão com a internet",
              errorLogin: true,
              right: "center",
              top: "top"
            }); // emit the event to the bus
          }
          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    }
  },

  getters: {
    getBalanceReport(state) {
      return state.balanceReport;
    },
    getChartReportEnt(state) {
      // if (localStorage.getItem("sibs_I")) return atob(localStorage.getItem("sibs_I"));
      return state.chartTransactionEnt;
    }
  }
};
